import type {Day} from 'date-fns'
import nextDay from 'date-fns/nextDay'

import {getTimeDifference} from '../../../../../../../../../../utils/dateTimeUtils'
import {amountDaysOfWeek, weekDaysShort} from '../JobTriggerForm/JobTriggerForm.consts'

import {dayLabel} from './PipelineTrigger.consts'

export function getNextTriggerDate(
  daysOfWeek: string[],
  hour: number,
  minutes: number,
  isEveryDay: boolean,
) {
  const [firstDay] = daysOfWeek
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()
  const currentDay = currentDate.getDate()
  const triggerDayWeekNumber = weekDaysShort.findIndex(day => day === firstDay)
  const triggerDate = new Date(currentYear, currentMonth, currentDay, hour, minutes)
  const isToday = triggerDayWeekNumber === currentDate.getDay()
  const triggerNextDayNumber = isEveryDay ? currentDate.getDay() + 1 : triggerDayWeekNumber
  const triggerNextDayDate = isToday
    ? triggerDate
    : nextDay(triggerDate, triggerNextDayNumber as Day)

  return getTimeDifference(currentDate, triggerNextDayDate)
}

export function getDaysOfWeekLabel(parameterDaysOfWeek?: string) {
  const daysOfWeek = parameterDaysOfWeek ? parameterDaysOfWeek.split(',') : []
  const isEveryDay = daysOfWeek.length === amountDaysOfWeek || !daysOfWeek.length

  if (isEveryDay) {
    return dayLabel
  } else {
    return daysOfWeek.join(', ')
  }
}

export function getTimeLabel(parameters: Record<string, string>) {
  const {hour: parameterHour = '00', minute: parameterMinute = '00'} = parameters
  return `${parameterHour}:${parameterMinute}`
}
